
$(document).ready(function () {
    if ($('.useCustomPageHeader').length > 0) {
        var theme = $('.useCustomPageHeader').data('theme');
        $('body').addClass('full-bleed theme-' + theme);
    }
});